import { Flex, Input, InputGroup, InputLeftElement, InputRightElement } from "@chakra-ui/react";
import { ArrowCounterClockwise, MagnifyingGlass } from "phosphor-react";
import React from "react";
import { COLORS } from "../../../../Helper/Colors";

export const Search = ({ search, onChange, resetSearch, placeholder = "", borderColor }) => {
	return (
		<Flex minWidth={"300px"}>
			<InputGroup boxShadow={COLORS.tableBoxShadow} size={"lg"}>
				<InputLeftElement
					pointerEvents='none'
					color='gray.300'
					fontSize='1.2em'
					children={<MagnifyingGlass size={24} color={COLORS.brand} />}
				/>
				<Input
					borderColor={borderColor ? borderColor : COLORS.light}
					borderRadius={"5px"}
					placeholder={`Search ${placeholder}`}
					value={search}
					backgroundColor={COLORS.light}
					onChange={onChange}
				/>
				<InputRightElement
					cursor={search ? "pointer" : "not-allowed"}
					onClick={resetSearch}
					children={<ArrowCounterClockwise size={24} color={search ? COLORS.mediumGray : "#eeee"} />}
				/>
			</InputGroup>
		</Flex>
	);
};
